var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _g, _g2, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUniversityGeneralPrinting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "printer",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_55288",
    "data-name": "Path 55288",
    d: "M35.859,99.375H31.172A1.171,1.171,0,0,1,30,98.2V93.516A3.52,3.52,0,0,1,33.516,90h2.344a1.171,1.171,0,0,1,1.172,1.172V98.2A1.171,1.171,0,0,1,35.859,99.375Z",
    transform: "translate(-27.656 -82.969)",
    fill: "#63c5b7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55289",
    "data-name": "Path 55289",
    d: "M371.375,98.2a1.171,1.171,0,0,1-1.172,1.172h-4.687a1.171,1.171,0,0,1-1.172-1.172L362,91.172A1.171,1.171,0,0,1,363.172,90h4.688a3.52,3.52,0,0,1,3.516,3.516Z",
    transform: "translate(-333.719 -82.969)",
    fill: "#63c5b7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55290",
    "data-name": "Path 55290",
    d: "M115.938,9.375v5.859a1.16,1.16,0,0,1-1.172,1.172H91.172A1.16,1.16,0,0,1,90,15.234V1.172A1.16,1.16,0,0,1,91.172,0h15.391l2.344,7.031Z",
    transform: "translate(-82.969)",
    fill: "#dff9ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55291",
    "data-name": "Path 55291",
    d: "M267.8,16.406H256V0h3.594l2.344,7.031,7.031,2.344v5.859A1.161,1.161,0,0,1,267.8,16.406Z",
    transform: "translate(-236)",
    fill: "#c5e0dc"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55292",
    "data-name": "Path 55292",
    d: "M36.484,180H3.516A3.511,3.511,0,0,0,0,183.516v14.219a3.511,3.511,0,0,0,3.516,3.516H36.484A3.511,3.511,0,0,0,40,197.734V183.516A3.511,3.511,0,0,0,36.484,180Z",
    transform: "translate(0 -165.938)",
    fill: "#63c5b7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55293",
    "data-name": "Path 55293",
    d: "M302,8.2a1.16,1.16,0,0,0,1.172,1.172h8.2L302,0Z",
    transform: "translate(-278.406)",
    fill: "#387f75"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55294",
    "data-name": "Path 55294",
    d: "M276,183.516v14.219a3.511,3.511,0,0,1-3.516,3.516H256V180h16.484A3.511,3.511,0,0,1,276,183.516Z",
    transform: "translate(-236 -165.938)",
    fill: "#387f75"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55295",
    "data-name": "Path 55295",
    d: "M63.516,242.344H61.172a1.172,1.172,0,0,1,0-2.344h2.344a1.172,1.172,0,0,1,0,2.344Z",
    transform: "translate(-55.313 -221.25)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55296",
    "data-name": "Path 55296",
    d: "M115.938,320v13.828A1.161,1.161,0,0,1,114.766,335H91.172A1.16,1.16,0,0,1,90,333.827V320Z",
    transform: "translate(-82.969 -294.999)",
    fill: "#dff9ff"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55297",
    "data-name": "Path 55297",
    d: "M268.969,320v13.828A1.161,1.161,0,0,1,267.8,335H256V320Z",
    transform: "translate(-236 -294.999)",
    fill: "#c5e0dc"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48129",
    "data-name": "Group 48129",
    transform: "translate(11.719 28.281)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55298",
    "data-name": "Path 55298",
    d: "M166.563,363.172a1.161,1.161,0,0,1-1.172,1.172H151.172a1.172,1.172,0,1,1,0-2.344h14.219A1.16,1.16,0,0,1,166.563,363.172Z",
    transform: "translate(-150 -362)",
    fill: "#63c5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55299",
    "data-name": "Path 55299",
    d: "M166.563,423.172a1.161,1.161,0,0,1-1.172,1.172H151.172a1.172,1.172,0,1,1,0-2.344h14.219A1.16,1.16,0,0,1,166.563,423.172Z",
    transform: "translate(-150 -417.313)",
    fill: "#63c5b7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48130",
    "data-name": "Group 48130",
    transform: "translate(20 28.281)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55300",
    "data-name": "Path 55300",
    d: "M264.281,423.172a1.16,1.16,0,0,1-1.172,1.172H256V422h7.109A1.16,1.16,0,0,1,264.281,423.172Z",
    transform: "translate(-256 -417.313)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55301",
    "data-name": "Path 55301",
    d: "M264.281,363.172a1.16,1.16,0,0,1-1.172,1.172H256V362h7.109A1.16,1.16,0,0,1,264.281,363.172Z",
    transform: "translate(-256 -362)",
    fill: "#387f75"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55302",
    "data-name": "Path 55302",
    d: "M90.625,303.172a1.161,1.161,0,0,1-1.172,1.172H61.172a1.172,1.172,0,0,1,0-2.344H89.453A1.16,1.16,0,0,1,90.625,303.172Z",
    transform: "translate(-55.313 -278.406)",
    fill: "#c3f2e9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55303",
    "data-name": "Path 55303",
    d: "M271.313,303.172a1.161,1.161,0,0,1-1.172,1.172H256V302h14.141A1.16,1.16,0,0,1,271.313,303.172Z",
    transform: "translate(-236 -278.406)",
    fill: "#dff9ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversityGeneralPrinting);
export default __webpack_public_path__ + "static/media/university-general-printing.45076a8cdf1fab08e04446946697033c.svg";
export { ForwardRef as ReactComponent };